import Toggle from "components/shared/toggle";
import { DARK } from "constants/theme";
import React, { useEffect } from "react";

export const ToggleTheme = ({ toggleTheme, theme }) => {
    useEffect(() => {
        document.documentElement.setAttribute("data-theme", theme);
        localStorage.setItem("theme", theme);
    }, [theme]);

    return (
        <div className="ml-auto d-flex align-items-center position-relative">
            <span className="mr-3 text-nowrap">DARK MODE</span>
            <Toggle className="switch-theme" onChange={toggleTheme} value={theme === DARK} />
        </div>
    );
};
